import en from '@/lang/en.json';
import zh from '@/lang/zh.json';

export const findIntl = (code: string): string => {
  const currentLanguage = navigator.language;
  let lang;
  switch (currentLanguage) {
    case 'zh-CN':
    case 'zh':
      lang = zh;
    default:
      lang = en;
  }
  return (lang as any)[code] || '';
};
